/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import ContactHeader from './ContactHeader';
import UpdateContactForm from '@/components/forms/UpdateContactForm';
import { useListContactsQuery } from '@/features/contacts/contactsApi';

const ViewContactDrawerWrapper = () => {
	const data = useSelector((state) => state.dialog.data.editContact);

	const { data: contacts, ...contactQuery } = useListContactsQuery(data.clientId, {
		skip: !data.clientId,
		selectFromResult: ({ data, ...rest }) => {
			const contacts = data ?? [];
			return {
				...rest,
				data: contacts,
			};
		},
	});

	const contact = data?.contactId
		? contacts?.find((c) => String(c.Id) === String(data.contactId))
		: contacts?.find((c) => c.isMainContact);

	return (
		<Box
			sx={{
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				minHeight: 0,
				pb: 2,
			}}
		>
			{contactQuery.isLoading && !contact && (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '200px',
					}}
				>
					<CircularProgress />
				</Box>
			)}

			{contact ? (
				<>
					
						<ContactHeader contact={contact} />
					
					<UpdateContactForm {...{ contactData: contact }} />
				</>
			) : (
				!contactQuery.isLoading && (
					<Typography variant='body1' color='error'>
						Error retrieving contact information.
					</Typography>
				)
			)}
		</Box>
	);
};

const ViewContactDrawer = () => {
	const dispatch = useDispatch();

	const open = useSelector((state) => state.dialog.open.editContact);

	const toggleDrawer = () => {
		dispatch(closeDialog('editContact'));
	};

	return (
		<FolioDrawer open={open} onClose={toggleDrawer} size='narrow' title='Contact Details'>
			{open && <ViewContactDrawerWrapper />}
		</FolioDrawer>
	);
};

export default ViewContactDrawer;
